import request from '@/plugins/axios'

//获取活动主题列表
export function listTheme(params) {
  return request({
    url: '/pictureActivityTheme/listTheme',
    method: 'get',
    params
  })
}

//添加活动主题
export function addTheme(data) {
  return request({
    url: '/pictureActivityTheme/addTheme',
    method: 'post',
    data
  })
}

//获取可用的活动主题列表
export function listAllowTheme() {
  return request({
    url: '/pictureActivityTheme/listAllowTheme'
  })
}

//删除活动主题
export function deleteTheme(params) {
  return request({
    url: '/pictureActivityTheme/deleteTheme/' + params,
    method: 'get'
  })
}

//查询单个活动主题
export function getTheme(params) {
  return request({
    url: '/pictureActivityTheme/getTheme/' + params,
    method: 'get'
  })
}

//修改活动主题信息
export function updateTheme(data) {
  return request({
    url: '/pictureActivityTheme/updateTheme',
    method: 'post',
    data
  })
}